import React, { Fragment, useContext, useEffect } from "react";
import { Link } from "react-router-dom";

import PostContext from "../../context/post/postContext";
import AuthContext from "../../context/auth/authContext"
import PostComposerV2 from "../posts/PostComposerV2";
import Carousel from "../layout/Carousel";
import Showcase from "../layout/Showcase";

import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';

const Gallery = () => {
  const postContext = useContext(PostContext);
  const authContext = useContext(AuthContext);

  const { posts, getPosts, loading } = postContext;
  const { loadUser } = authContext;

  useEffect(() => {
    loadUser();
    getPosts();
    //eslint-disable-next-line
  }, []);

  if (posts !== null && posts.length === 0 && !loading) {
    return (
      <Fragment>
        <br />
        <br />
        <div>
          <Grid container>
            <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
            <Grid size={{ xs: 12, sm: 10, lg: 4 }}>
              <h4>Welcome to your brand new album!</h4>
              <h4>Let's get started by adding a new memory.</h4>
              <PostComposerV2 />
            </Grid>
            <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
          </Grid>
        </div>
      </Fragment>
    );
  }
  const gallery_posts = posts.filter((post) => {
    return (
      post.cover_photo !== undefined &&
      post.cover_photo !== null &&
      post.is_favorite === true
    );
  });

  if (gallery_posts.length === 0 && !loading) {
    return (
      <Fragment>
        <br />
        <br />
        <div>
          <Grid container>
            <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
            <Grid size={{ xs: 12, sm: 10, lg: 4 }}>
              <h4>No photo to show. </h4>
              <h4>
                Favoirte (star) your existing photos to show in the Gallery.
              </h4>
              <Button
                component={Link}
                to="Memory"
                style={{ background: "#03a9f4" }}
                color="primary"
                variant="contained"
              >
                Go to favorite your photos
              </Button>
            </Grid>
            <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
          </Grid>
        </div>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <br />
      <br />
      <div>
        <Grid container>
          <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
          <Grid size={{ xs: 12, sm: 10, lg: 4 }}>
            <Carousel maxPhotoNum={5}/>
            <Showcase startPhotoNum={5} maxPhotoNumInOnePage={20}/>
          </Grid>
          <Grid size={{ xs: 0, sm: 1, lg: 4 }}></Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

export default Gallery;
